exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".btn-add-school-code[data-v-a93ebc38]{position:relative}.btn-add-school-code[data-v-a93ebc38]:before{font-family:FontAwesome;content:\"\\F271\";font-size:1.2rem;color:#fff;position:absolute;top:50%;transform:translateY(-50%) translateX(0);left:5%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-a93ebc38&scoped=true!./~/sass-loader!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/page/subPages/MyPage/Event/Organization.vue
// module id = 535
// module chunks = 0